const config = {
   attachement: true,
   videoDuaration: 40,
   audioDuaration: 60,
   fileSize: 1024 * 2,
   imageFileSize: 1024 * 2,
   videoFileSize: 1024 * 2,
   audioFileSize: 1024 * 2,
   documentFileSize: 1024 * 2,
   maxAllowedMediaCount: 10,
   maximumAllowedUsersToForward: 5,
   maximumCharForwardPopUp: 60,
   helpUrl: 'https://app.mirrorfly.com/webchat-log-in/index.html',
   demoUrl: 'localhost',
   boxLayout: true,
   reportMembers: 5,
   defaultStatus: "I am on MirrorFly Teams",
   minGroupMembers: 2,
   maxGroupMembers: 256,
   deleteForEveryOneDurationInSec: Number(import.meta.env.VITE_DELETE_FOR_EVERYONE_DURATION_IN_SEC) || 300,
   fetchMediaFromServer: false,
   // Audio Recorder — getter so URL ?audioLimit=N overrides at runtime (used by E2E)
   get audioLimitInSec() {
      if (typeof window !== 'undefined') {
         const fromUrl = Number(new URLSearchParams(window.location.search).get('audioLimit'));
         if (fromUrl > 0) return fromUrl;
      }
      return Number(import.meta.env.VITE_AUDIO_LIMIT_IN_SEC) || 300;
   },
   maxCallParticipants: 20,
   userDomain: '@contus.in',
};
export default config;
